module.exports = __webpack_public_path__ + "static/media/tidal-logo-black.c6d0066c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/promos/tidal/tidal-logo-black.svg
// module id = 487
// module chunks = 0